import Icon from '../../../../../../assets/global_jobs_dark.svg?react';
import GlobalDetail from '../../../../../../components/updatejobs/GlobalDetail';
import GlobalList from '../../../../../../components/updatejobs/GlobalList';
import GlobalCreate from '../../../../../../components/updatejobs/GlobalCreate';
import {READ_GLOBAL_JOB, CREATE_GLOBAL_JOB} from '../../../../../../components/updatejobs/consts';
import {isRafiDeviceStockAssetGroup} from '../../routeHelper';
import {ContextInfoProps, RouteConfig} from '@deviceinsight/ng-ui-scale-lib/api';

const createRoute = {
	relativePath: 'create',
	label: {
		id: 'assetgroup.detail.globaljobs.create.title',
		defaultValue: 'Create Global Job'
	},
	component: GlobalCreate,
	requiredAuthorities: [CREATE_GLOBAL_JOB]
} satisfies RouteConfig;

const detailsRoute = {
	relativePath: ':id',
	label: {
		id: 'assetgroup.detail.globaljobs.title',
		defaultValue: 'Global Job'
	},
	component: GlobalDetail,
	requiredAuthorities: [READ_GLOBAL_JOB]
} satisfies RouteConfig;

export default {
	relativePath: 'globaljobs',
	label: {
		id: 'assetgroup.detail.globaljobs.title',
		defaultValue: 'Global Jobs'
	},
	component: GlobalList,
	iconSvg: Icon,
	childRoutes: [createRoute, detailsRoute],
	requiredAuthorities: [READ_GLOBAL_JOB],
	show: (context: ContextInfoProps['contextInfo'] | null | undefined) => isRafiDeviceStockAssetGroup(context)
} satisfies RouteConfig;
